import { repository } from '@/api/base'

export default {
  async findAll(pageNumber = 0, filters = {}, options = {}) {
    const { data } = await repository.post(`/dictionary/subgroup/findAll/${pageNumber}`, filters, {
      signal: options.signal
    })
    return data
  },

  async findById(id) {
    const { data } = await repository.get(`/dictionary/subgroup/${id}`)
    return data
  },

  async create(body, flag = true) {
    const { data } = await repository.post(`/dictionary/subgroup?isScheduleLectureTypeCheckRequired=${flag}`, body)
    return data
  },

  async update(body, flag = true) {
    const { data } = await repository.put(`/dictionary/subgroup?isScheduleExistsCheckRequired=${flag}`, body)
    return data
  },

  async delete(id) {
    const { data } = await repository.delete(`/dictionary/subgroup/${id}?isScheduleExistsCheckRequired=true`)
    return data
  }
}

//subgroup
